module.exports = __webpack_public_path__ + "img/Flag_of_Thailand.9667e838.svg";